module.exports = __webpack_public_path__ + "media/images/footer/animafac-4c1f4a62510e7ef29332af67ee2a773b.png";